import { ChevronDown } from 'lucide-react';
import { Checkbox as CheckboxPrimitive } from 'radix-ui';
import { Icon } from '@/components/Icon';
import * as styles from './index.css';

type CheckboxProps = CheckboxPrimitive.CheckboxProps;

export function Checkbox(props: CheckboxProps) {
    return (
        <CheckboxPrimitive.Root className={styles.root} {...props}>
            <CheckboxPrimitive.Indicator className={styles.indicator}>
                <Icon icon={ChevronDown} size="sm" />
            </CheckboxPrimitive.Indicator>
        </CheckboxPrimitive.Root>
    );
}
